import Details from '../../../../assets/src/js/classes/Details';

import '../sass/winners.scss';

(() => {
    const $winners = document.querySelectorAll('.winners');

    if (!$winners) return;

    $winners.forEach(($winners) => {
        const $filterDropdown = $winners.querySelector('.winners__filter-dropdown');
        const $filterForms = $winners.querySelectorAll('.winners__filter-form');

        const initFilterDropdown = () => {
            if (!$filterDropdown) return;
            
            new Details($filterDropdown);
        };

        const initFilterForms = () => {
            $filterForms.forEach($filterForm => {
                const $selects = $filterForm.querySelectorAll('select');

                $selects.forEach($select => {
                    $select.addEventListener('change', () => {
                        $filterForm.submit();
                    });
                })
            });
        };

        initFilterDropdown();
        initFilterForms();
    });
})();
